import { render, staticRenderFns } from "./PgaOfferEvaluationTotalCostsDetails.vue?vue&type=template&id=6fb234b1&scoped=true&"
import script from "./PgaOfferEvaluationTotalCostsDetails.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationTotalCostsDetails.vue?vue&type=script&lang=ts&"
import style0 from "./PgaOfferEvaluationTotalCostsDetails.vue?vue&type=style&index=0&id=6fb234b1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb234b1",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VExpansionPanel,VExpansionPanelContent,VExpansionPanelHeader,VFadeTransition,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb234b1')) {
      api.createRecord('6fb234b1', component.options)
    } else {
      api.reload('6fb234b1', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationTotalCostsDetails.vue?vue&type=template&id=6fb234b1&scoped=true&", function () {
      api.rerender('6fb234b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/details/sub-components/PgaOfferEvaluationTotalCostsDetails.vue"
export default component.exports